import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { returnUnit } from './utils/kiln-card-utils';

export default function CbCard({ setKilnDetails, kilnDetails, pileType }) {
    const [isActive, setIsActive] = useState(null)
    const { selectedProject } = useSelector(state => state.postFormData);
    const currentProjectMeasurementSystem = selectedProject.measureType

    // listen to changes in kilnDetails, and reset if submission has taken place
    useEffect(() => {
        if (kilnDetails.kilnId === null) {
            setIsActive(null)
        }
    }, [kilnDetails])

    const kilnCardDetailsFontSize = 18

    const cbConstants = {
        units: returnUnit(currentProjectMeasurementSystem),
        kilnType: 'Conservation Burn - ' + (pileType === 'Hand Pile' ? 'Hand Pile' : 'Machine Pile'),
    }

    const cbCardObjects = [
        {
            kilnId: "6_by_6",
            height: 6,
            diameter: 6,
            ...cbConstants
        },
        {
            kilnId: "8_by_8",
            height: 8,
            diameter: 8,
            ...cbConstants
        },
        {
            kilnId: "12_by_12",
            height: 12,
            diameter: 12,
            ...cbConstants
        },
        {
            kilnId: "20_by_20",
            height: 20,
            diameter: 20,
            ...cbConstants
        },
    ]

    return (
        <Box sx={{
            width: '100%',
            maxWidth: '1500px',
            display: 'grid',
            // flexWrap: 'wrap',
            gridTemplateColumns: 'repeat(4, 1fr)',
            // placeSelf: 'center', 
            rowGap: 3,
            columnGap: 1,
            p: 4
        }}>
            {
                cbCardObjects.map((cbCardObject, index) => (
                    <Box key={index}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: 'fit-content',
                            textAlign: 'left',
                            color: '#000',
                            border: '1px solid #000',
                            borderRadius: '5px',
                            padding: 2,
                            cursor: 'pointer',
                            '&:hover': {
                                boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                            },
                            ...(isActive === index && {
                                background: 'linear-gradient(to bottom right, #535988, #313551)',
                                color: '#FFF', boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px'
                            })

                        }}
                        onClick={() => {
                            setIsActive(index);
                            setKilnDetails(cbCardObject);
                        }}
                    >
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', pb: 3, gap: 1 }}>
                            <Typography sx={{ fontSize: 25, pt: 2, pb: 2, fontWeight: 'bold' }}>
                                {`${cbCardObject.height}x${cbCardObject.diameter} ${pileType}`}
                            </Typography>
                            <img src='/cb-image.png' alt='Kiln' height={80} style={{ objectFit: 'contain' }} />
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1 }}>
                            <Typography sx={{ fontSize: kilnCardDetailsFontSize }}>Height:</Typography>
                            <Typography sx={{ fontSize: kilnCardDetailsFontSize, fontWeight: 'bold' }}>
                                {cbCardObject.height} {returnUnit(cbCardObject.units)}
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1 }}>
                            <Typography sx={{ fontSize: kilnCardDetailsFontSize }}>Diameter:</Typography>
                            <Typography sx={{ fontSize: kilnCardDetailsFontSize, fontWeight: 'bold' }}>
                                {cbCardObject.diameter} {returnUnit(cbCardObject.units)}
                            </Typography>
                        </Box>
                    </Box>
                ))
            }
        </Box>
    )
}
